import React from 'react'
import {Navigate} from 'react-router-dom'
import {Documente} from '../../containers/MainPage/views'
import DocumenteRoutes from '../../containers/MainPage/routes/DocumentRoutes'
import Reguli from '../../containers/RulesPage/views/Reguli'
import SettingsRoutes from "../../containers/SettingsPage";
import ReguliArticole from '../../containers/ArticleRulesPage/views/ReguliArticole'
import PartnersView from '../../containers/PartnersPage/views/PartnersView'

export const admin = [
    {path: 'documente', element: <Documente/>},
    {path: 'documente/*', element: <DocumenteRoutes/>},
    {path: 'parteneri', element: <PartnersView/>},
    {path: 'reguli', element: <Reguli/>},
    {path: 'reguliArticole', element: <ReguliArticole/>},
    {path: 'setari', element: <SettingsRoutes/>},
    {path: '*', element: <Navigate to="/documente"/>}
]
